// Roles shown in the "Join Our Team" dropdown. Edit freely; the list is also
// used to validate applications on the server (netlify/functions/apply.mjs).
export const careerRoles = [
  "Roofing Installer",
  "Roofing Foreman / Crew Lead",
  "Roof Inspector / Estimator",
  "Sales Representative",
  "Project Manager",
  "Tile Roof Specialist",
  "Foam / Flat Roof Technician",
  "General Laborer",
  "Office / Administrative",
  "Subcontractor / Trade Partner",
  "Other",
];

export const experienceLevels = ["Less than 1 year", "1–2 years", "3–5 years", "6–10 years", "10+ years"];

export const employmentTypes = ["Full-time", "Part-time", "Contract / 1099", "Any"];

export const RESUME_MAX_MB = 4;
export const RESUME_TYPES = [".pdf", ".doc", ".docx"];

export const usStates = ["AL","AK","AZ","AR","CA","CO","CT","DE","DC","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];
